import { create } from "../../../common/utils/zustand_state_manager";
import { useControleDocumentosServices } from "./use_services";
import { ControleDocumentosRepository } from "../../../features/controleDocumentos/data/repositories/controle_documentos_repository";
import { IControleDocumentosRepository } from "../../../features/controleDocumentos/domain/repositories/controle_documentos_repository";

/**
 * useControleDocumentosRepositories
 */

type State = {
  controleDocumentosRepository: IControleDocumentosRepository,
};

export const useControleDocumentosRepositories = create<State>((set, get) => {
  const { controleDocumentosService } = useControleDocumentosServices.getState();
  return ({
    controleDocumentosRepository: new ControleDocumentosRepository(controleDocumentosService),
  });
});